export default __webpack_public_path__ + "img/pin_icons/apartment_b.png";